import React, { useEffect } from "react"
import { AnimatePresence, motion } from 'framer-motion'
import { MdDoneAll, MdWarning } from "react-icons/md";
import { IoMdCloseCircle } from "react-icons/io";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";

let timeout = null;

const iconMap = {
    success: <MdDoneAll className="text-xl text-sColor" />,
    info: <BsFillInfoCircleFill className="text-xl text-sky-600" />,
    warning: <MdWarning className="text-xl text-amber-500" />,
    error: <IoMdCloseCircle className="text-xl text-[#c44545]" />,
}

const toneMap = {
    success: "border-sColor/20 bg-white/95",
    info: "border-sky-200 bg-white/95",
    warning: "border-amber-200 bg-white/95",
    error: "border-rose-200 bg-white/95",
}

const Alert = ({ type = "error", title, subtitle, active, setActive }) => {
    const toggleActive = () => {
        clearTimeout(timeout);
        if (typeof setActive === "function") setActive(!active);
    };

    useEffect(() => {
        if (active) timeout = setTimeout(() => toggleActive(), 5000);
    }, [active]); // eslint-disable-line

    return (
        <AnimatePresence>
            {active && (
                <motion.div
                    initial={{ opacity: 0, y: -18, x: 12 }}
                    animate={{ opacity: 1, y: 0, x: 0 }}
                    exit={{ opacity: 0, y: -14, x: 12 }}
                    className={`fixed right-4 top-4 z-[9999] flex min-h-16 w-[calc(100%-2rem)] max-w-md items-start gap-3 rounded-3xl border px-4 py-4 shadow-soft backdrop-blur-xl ${toneMap[type] || toneMap.error}`}
                >
                    <div className="mt-1 flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-100">
                        {iconMap[type] || iconMap.error}
                    </div>
                    <div className="flex-1">
                        {title ? <p className="text-sm font-extrabold uppercase tracking-[0.16em] text-tpColor">{title}</p> : null}
                        <p className="mt-1 text-sm font-medium leading-6 text-tColor">{subtitle}</p>
                    </div>
                    <button type="button" className="mt-1 text-tpColor transition hover:text-tColor" onClick={toggleActive}>
                        <FaTimes />
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default Alert
